<template>
    <div class="qrcode-box">
      <div class="cat-ear-deco"></div>
      
      <div class="input-group">
        <textarea
          v-model="inputText"
          placeholder="输入要变成二维码的内容喵~"
          class="meow-textarea"
          rows="3"
        ></textarea>
        <button 
          @click="generateQR"
          :disabled="!inputText || isLoading"
          class="paw-button"
        >
          🐾 {{ isLoading ? '正在抓老鼠生成中...' : '变二维码ฅ' }}
        </button>
      </div>
  
      <transition name="qr-bounce">
        <div v-if="qrImage" class="qr-result">
          <img :src="qrImage" alt="生成的二维码" class="qrcode-image" />
          <div class="hint">{{"长按可以保存喵~(๑>ᴗ<๑)"}}</div>
        </div>
      </transition>
  
      <div v-if="errorMsg" class="error-tip">
        😿 糟糕！{{ errorMsg }}
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref } from 'vue'
  import axios from 'axios'
  
  const apiUrl = 'https://api.vvhan.com/api/qr'
  const inputText = ref('')
  const qrImage = ref('')
  const isLoading = ref(false)
  const errorMsg = ref(null)
  
  const generateQR = async () => {
    if (!inputText.value.trim()) return
    
    try {
      isLoading.value = true
      errorMsg.value = null
      
      // 调用API生成二维码
      const response = await axios.get(apiUrl, {
        params: {
          text: inputText.value,
        },
        responseType: 'blob' // 接收二进制图片数据
      })
  
      // 将Blob转换成可显示的URL
      const imageUrl = URL.createObjectURL(response.data)
      qrImage.value = imageUrl
    } catch (err) {
      errorMsg.value = '纸箱被抓破啦，请重试喵~'
      console.error('生成失败:', err)
    } finally {
      isLoading.value = false
    }
  }
  </script>
  
  <style scoped>
  .qrcode-box {
    max-width: 400px;
    margin: 2rem auto;
    padding: 25px;
    background: #fff5f7;
    border-radius: 20px;
    position: relative;
    box-shadow: 0 8px 20px rgba(255,182,193,0.2);
  }
  
  .cat-ear-deco::before,
  .cat-ear-deco::after {
    content: '';
    position: absolute;
    top: -20px;
    width: 30px;
    height: 40px;
    background: #ffb3cb;
    clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
  }
  .cat-ear-deco::before { left: 20px; }
  .cat-ear-deco::after { right: 20px; }
  
  .meow-textarea {
    width: 100%;
    padding: 12px 0;
    border: 2px solid #ffacc7;
    border-radius: 15px;
    resize: vertical;
    font-size: 16px;
    margin-bottom: 15px;
  }
  
  .paw-button {
    background: #ff9eb5;
    border: none;
    padding: 12px 25px;
    border-radius: 25px;
    color: white;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.3s;
  }
  
  .paw-button:hover:not(:disabled) {
    transform: scale(1.05) rotate(3deg);
    background: #ff7d9f;
  }
  
  .paw-button:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
  
  .qr-result {
    margin-top: 20px;
    text-align: center;
  }
  
  .qrcode-image {
    width: 200px;
    height: 200px;
    border: 5px solid white;
    border-radius: 15px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  }
  
  .hint {
    margin-top: 10px;
    color: #666;
    font-size: 0.9em;
  }
  
  .error-tip {
    margin-top: 15px;
    padding: 10px;
    background: #ffe5e5;
    border-radius: 10px;
    color: #ff4444;
  }
  
  .qr-bounce-enter-active {
    animation: bounce 0.5s;
  }
  
  @keyframes bounce {
    0% { transform: scale(0.9); opacity: 0; }
    70% { transform: scale(1.05); }
    100% { transform: scale(1); opacity: 1; }
  }
  </style>
  